import { ProductType } from '../enums';

export interface CompanyMenu {
  has_active_subscriptions: boolean;
  has_active_non_subscription_campaign_period: boolean;
  company_group_id: string;
  id: string;
  product_types: ProductType[];
}
